import React, { useEffect, useState } from "react";
import { sendDocuseal } from "../../../apis/docusealApi";
import { DocusealForm } from "@docuseal/react";
import { useNavigate, useParams } from "react-router-dom";

const Docuseal = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [data, setData] = useState(false);
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    try {
      setLoading(true);
      const res = await sendDocuseal(id);
      if (res.success) {
        setData(res.result);
      } else {
        setError(true);
      }
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <div>Loading...</div>}
      {error && <div>URL Is Invalid</div>}
      {!loading && !error && data && (
        <div className="app">
          <div className="page-title-box">
            <h3>GM Open</h3>
          </div>
          <DocusealForm
            src={`https://docuseal.co/d/${data.docusealSlug}`}
            email={
              data?.subscriptionInfo?.subSubscribers?.subscribers?.email ||
              "praveen.node@gmail.com"
            }
            onComplete={(data) => console.log(data)}
          />
        </div>
      )}
    </div>
  );
};

export default Docuseal;
